export default function Subtraction() {
  return (
    <div className="p-4">
      <h1>Subtraction</h1>
    </div>
  );
}
